import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteJobSearchHistory,
  fetchJobSearchHistory,
} from "./jobSearchHistoryAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobSearchHistoryAsync = createAsyncThunk(
  "JobSearchHistory/fetch",
  async ({ token }, { rejectWithValue }) => {
    try {
      const data = await fetchJobSearchHistory(token);

      const resp = data?.response;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteJobSearchHistoryAsync = createAsyncThunk(
  "JobSearchHistory/delete",
  async ({ token, uuid }, { rejectWithValue }) => {
    try {
      await deleteJobSearchHistory(token, uuid);
      return uuid;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const JobSearchHistorySlice = createSlice({
  name: "JobSearchHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobSearchHistoryAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobSearchHistoryAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchJobSearchHistoryAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(deleteJobSearchHistoryAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJobSearchHistoryAsync.fulfilled, (state, action) => {
        state.loading = false;
        // console.log("history", state.data);
        state.data = state.data.filter(
          (data) => data.uuid !== action.payload
        );
      })
      .addCase(deleteJobSearchHistoryAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectJobSearchHistory = (state) => state.jobSearchHistory.data;

export default JobSearchHistorySlice.reducer;
